import script from "./DataDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DataDrawer.vue?vue&type=style&index=0&id=a255fe5a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a255fe5a"]])

export default __exports__